export const TIPO_TAREFA_URGENTE = 4;

// Prefeitura:
export const TIPO_USER = 8;

// Privado:
// export const TIPO_USER = 2;